<template>
  <div id="app">
    <!-- <router-view/> -->
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      isRouterAlive: true,
    };
  },
  provide () {
    // 提供
    return {
      reload: this.reload,
    };
  },
  methods: {
    // 设置页面标题
    setPageTitleAndIcon () {
      document.querySelectorAll("link[rel*='icon']").forEach((item) => {
        item.href = this.$util.tagIcon();
      });
      document.title = this.$util.tagTitle();
    },
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    disableScaling () {
      // 禁止通过 ctrl + +/- 和 ctrl + 滚轮 对页面进行缩放
      document.addEventListener('keydown', (event) => {
        if ((event.ctrlKey === true || event.metaKey === true)
          && (event.code === 'Minus' || event.code === 'Equal' || event.code === 'NumpadAdd' || event.code === 'NumpadSubtract')) {
          event.preventDefault();
        }
      }, false);
      // Chrome IE 360
      window.addEventListener('mousewheel', (event) => {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      }, {
        passive: false,
      });

      // firefox
      window.addEventListener('DOMMouseScroll', (event) => {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      }, {
        passive: false,
      });
    },
  },
  created () {
    this.disableScaling();
    this.setPageTitleAndIcon();

    if (!['/', '/loginEditPass', '/forget'].includes(this.$route.path) && sessionStorage.getItem('登录系统') != 'SCM') {
      this.$message.show({ text: '请先登录', type: 'warning' });
      this.$router.push({ path: '/' });
    }

    if (Number(localStorage.getItem('SMP_PAGE_COUNT')) > this.$util.每页条数最大值) {
      localStorage.setItem('SMP_PAGE_COUNT', this.$util.每页条数最大值);
    }
  },
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, 'PingFang SC', 'Helvetica Neue', 'Hiragino Sans GB', 'Segoe UI', 'Microsoft YaHei', '微软雅黑', 'sans-serif', 'Microsoft YaHei';
  /* font-family: 'PingFang SC','Helvetica Neue','Hiragino Sans GB','Segoe UI','Microsoft YaHei','微软雅黑','sans-serif','Microsoft YaHei', */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: #f5f7f9;
}

.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
}

html {
  height: 100%;
  width: 100%;
}

body {
  padding: 0;
  margin: 0;
  color: #333;
  height: 100%;
  width: 100%;
  min-width: 1000px;
}

div>>>.el-tabs__item {
  padding-left: 20px !important;
  width: fit-content !important;
}

.el-button {
  margin-right: 10px !important;
  margin-left: 0 !important;
}

.my-autocomplete-popper {
  width: auto !important;
  /* 确保宽度可以被动态设置 */
}

.el-drawer__body {
  padding: 20px;
}

/* 信息标签两端对齐，替代 &nbsp; 对齐方案 */
.info-label {
  display: inline-block;
  width: 5em;
  text-align: justify;
  text-align-last: justify;
  vertical-align: middle;
}

/* 信息列表标签两端对齐：容器内每个 li 的首个 span 视为标签（仅文字，冒号由模板放在 span 外） */
.info-list li>span:first-child {
  display: inline-block;
  width: 5em;
  text-align: justify;
  text-align-last: justify;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/App.vue